import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { SubmitDocumentRequest } from '../../api/submit-document/submitDocument.types';
import type { UseSubmitDocumentReturn } from './useSubmitDocument.types';

import { submitDocument } from '../../api/submit-document/submitDocument';

export function useSubmitDocument(
  organizationId: string
): UseSubmitDocumentReturn {
  const queryClient = useQueryClient();

  return useMutation<void, Error, SubmitDocumentRequest>({
    mutationFn: (request: SubmitDocumentRequest): Promise<void> =>
      submitDocument(request, organizationId),
    onSuccess: (): void => {
      queryClient.invalidateQueries({ queryKey: ['documents', 'Submitted'] });
    },
  });
}
